import type { ReactNode } from 'react';

export type StatTone = 'ink' | 'ok' | 'warn' | 'risk' | 'accent';

const COLORS: Record<StatTone, string> = {
  ink: 'var(--apm-ink)',
  ok: 'var(--apm-ok)',
  warn: 'var(--apm-warn)',
  risk: 'var(--apm-risk)',
  accent: 'var(--apm-accent)',
};

export interface StatProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  tone?: StatTone;
  spark?: ReactNode;
}

export function Stat({ label, value, sub, tone = 'ink', spark }: StatProps) {
  return (
    <div>
      <div
        style={{
          fontSize: 11.5,
          color: 'var(--apm-muted)',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          fontWeight: 500,
          marginBottom: 8,
        }}
      >
        {label}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <div
          style={{
            fontFamily: 'var(--apm-font-display)',
            fontSize: 'var(--apm-text-2xl)',
            lineHeight: 1,
            color: COLORS[tone],
          }}
        >
          {value}
        </div>
        {sub && (
          <div style={{ fontSize: 12.5, color: 'var(--apm-muted)' }}>{sub}</div>
        )}
      </div>
      {spark && <div style={{ marginTop: 6 }}>{spark}</div>}
    </div>
  );
}
